import { COMMA, ENTER } from '@angular/cdk/keycodes';

import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatSelectChange } from '@angular/material/select';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

import { NgxSpinnerService } from 'ngx-spinner';
import { GenericEdit } from 'src/app/interfaces/generic-edit';
import { DynamicFormsService } from 'src/app/services/dynamic-forms.service';
import { HTTPService } from 'src/app/services/http.service';
import { PermissionServices } from 'src/app/services/permission.services';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { Variations } from '../shopee-var-tier/shopee-var-tier.component';
import { ThemeService } from 'src/app/services/theme.service';


@Component({
    selector: 'app-shopee-var',
    templateUrl: './shopee-var.component.html',
    styleUrls: ['./shopee-var.component.scss'],
    standalone: false
})
export class ShopeeVarComponent implements OnInit {

  
  formVinculo:UntypedFormGroup;
  showVariationOptions = false;
  tiers:number[] = [];
  permission: import("src/app/interfaces/RolePermission").ItensPermission;
  constructor(  private fb:UntypedFormBuilder, 
                private http:HTTPService, 
                private sanitizer:DomSanitizer, 
                private spinner:NgxSpinnerService,
                private snackBar:SnackbarService,
                private ap:PermissionServices,
                public ThemeService:ThemeService,
                public dynamicServices:DynamicFormsService) { }
  
  codeproduct = 1;
  codecompany = 122;
  codeshopee = 2;
  codecontract = 2;
  @Output() saving:EventEmitter<boolean> = new EventEmitter();
  data:GenericEdit;
  row:Object = [];
  variations:Variations[] = null;
  disabled = true;


  refreshData(){

      return new Promise((resolve,reject)=>{  
        let ob = {
          "entityName":"Mktpshopee",
          "sql":`SELECT TIERVARIATION
                FROM MKTPSHOPEE A 
                WHERE A.CODECOMPANY=${this.codecompany}
                AND A.CODEPRODUCT = ${this.codeproduct}
                AND A.CODESHOPEE = ${this.codeshopee}
                AND A.CODECONTRACT = ${this.codecontract}`
        }
         
          this.http.post(ob,'JsonBrokerServices/findnative',false,true,true).subscribe(con=>{
                let sql  =  con['SQL'];
                if ( sql ){
                    if ( sql[0]){
                        if ( sql[0]['TIERVARIATION']){
                          try{
                            this.variations =  JSON.parse(sql[0]['TIERVARIATION']);
                          }catch(Exceptione){
                            this.variations = [];
                          }
                          
                        }
                    }
                }

                if ( this.variations == null  || this.variations.length == 0  ){
                  this.formVinculo.disable();
                  throw new Error('Não é possível adicionar variação sem estrutura.');
                }
                resolve(true);
          },error=>{
            reject(error);
            throw error;
          });
        });
  }

  ngOnInit(): void {
    
    this.formVinculo = this.data.formGroup;
    this.row = this.data.row;
    this.permission = this.ap.checkPermission('Mktpshopeevar');

    if ( this.data != null){  
      this.codecompany = this.data['parentRow']['linha']['CODECOMPANY'];
      this.codeproduct = this.data['parentRow']['linha']['CODEPRODUCT'];
      this.codeshopee = this.data['parentRow']['linha']['CODESHOPEE'];
      this.codecontract = this.data['parentRow']['linha']['CODECONTRACT'];
    }
    
    if ( this.data.evento == 'editando'){
        
      this.formVinculo.addControl("CODEPRODUCTVAR->NAME",new UntypedFormControl(this.row['FK_MKTPSHOPEEVAR_MKTPPRODUCTS->NAME']));
      this.formVinculo.addControl('CODEPRODUCTVAR',new UntypedFormControl(this.row['CODEPRODUCTVAR'],[Validators.required]));
      this.formVinculo.addControl('PRICE',new UntypedFormControl(this.row['PRICE'],[Validators.required]));
      this.formVinculo.addControl('QUANTITY',new UntypedFormControl(this.row['QUANTITY'],[Validators.required]));
      this.formVinculo.addControl('STATUS',new UntypedFormControl(this.row['STATUS']));
      this.formVinculo.addControl('REQUESTBODY',new UntypedFormControl(this.row['REQUESTBODY']));
      this.formVinculo.addControl('RESPONSEBODY',new UntypedFormControl(this.row['RESPONSEBODY']));
      this.formVinculo.addControl('ITEMID',new UntypedFormControl(this.row['ITEMID']));
    
      
      this.formVinculo.get("CODEPRODUCTVAR->NAME").disable();
      this.formVinculo.get("CODEPRODUCTVAR").disable();
      this.formVinculo.get("STATUS").disable();
      this.formVinculo.get("REQUESTBODY").disable();
      this.formVinculo.get("RESPONSEBODY").disable();
    }else{
    
      this.formVinculo.addControl('CODEPRODUCTVAR',new UntypedFormControl({value:null,disabled:false},{validators: Validators.required}));
      this.formVinculo.addControl("CODEPRODUCTVAR->NAME",new UntypedFormControl(this.row['FK_MKTPSHOPEEVAR_MKTPPRODUCTS->NAME']));
      this.formVinculo.addControl('PRICE',new UntypedFormControl({value:null,disabled:false},{validators: Validators.required}));
      this.formVinculo.addControl('QUANTITY',new UntypedFormControl({value:null,disabled:false},{validators: Validators.required}));
      this.formVinculo.addControl('ITEMID',new UntypedFormControl(this.row['ITEMID']));
    }

    this.formVinculo.addControl("CODECOMPANY",new UntypedFormControl(this.codecompany));
    this.formVinculo.addControl("CODEPRODUCT",new UntypedFormControl(this.codeproduct));
    this.formVinculo.addControl("CODESHOPEE",new UntypedFormControl(this.codeshopee));
    this.formVinculo.addControl("CODECONTRACT",new UntypedFormControl(this.codecontract));

    this.refreshData().then(data=>{
      
      if (this.data.evento == 'editando' ){
        this.mountgrid();
      }

      if ( this.variations.length > 0 ){
        let index = 0;
        try{
          this.tiers = JSON.parse(this.row['TIERINDEX']);
        }catch(Exception){
          this.tiers=[];
        }

        try{
          this.variations.forEach(variation=>{
            if ( this.data.evento == 'editando'){
              if ( this.tiers != null && this.tiers.length > 0 ){
                this.formVinculo.addControl(variation.name,new UntypedFormControl(this.tiers[index],[Validators.required]));
              }else{
                this.formVinculo.addControl(variation.name,new UntypedFormControl(null,[Validators.required]));
              }
              
            }else{
              this.formVinculo.addControl(variation.name,new UntypedFormControl(null,[Validators.required]));
            }
            index++;
          })
        }catch(Exception){}
        
      }

      
      if ( this.variations.length > 0){
          this.showVariationOptions = true;
      }
  
    }).catch(error=>{
        throw error;
    });

    this.formVinculo.valueChanges.subscribe(data=>{
      
      if ( this.formVinculo.valid && this.permission.canEdit){
        this.disabled = false;
      }else{
        this.disabled = true;
      }
    });
    this.disabled = true;

  }
  
  changeSelection(event:MatSelectChange){
      let id = event.source.id;
      let index = this.variations.findIndex(i=>i.name == id);
      this.tiers[index] = event.value;
  }

  salvar(){
    this.spinner.show("right-panel");
      
    let ob = this.formVinculo.getRawValue();
    ob['TIERINDEX'] = JSON.stringify(this.tiers);
    ob['STATUS'] = '0';

    
    let local = {
      entityName: 'Mktpshopeevar',
      remove:false,
      data: [ob]
    }

    this.http.post(local,'JsonBrokerServices/save',false,true,true).subscribe(result=>{
        this.snackBar.showSuccess("Registro modificado com sucesso");
        this.spinner.hide("right-panel");
        this.saving.next(true);
        this.disabled = true;
    },(ex)=>{
        this.spinner.hide("right-panel");
        throw ex;
    },()=>{
      this.spinner.hide("right-panel");
    });
  }

  mountgrid(){
    
    if ( this.variations != null && this.variations.length > 0){
      if ( ObjectUtil.isNotEmpty(this.formVinculo.get("CODEPRODUCTVAR->NAME").value)){
        this.showVariationOptions = true;
      }
    }
  }
  

}
